// src/firebase/firebase.ts
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";

const rawProjectId = import.meta.env.VITE_FIREBASE_PROJECT_ID;
const rawAuthDomain = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN;

// Guard against accidental sender-id in projectId (numeric-only value)
const inferredProjectId = (() => {
  if (typeof rawProjectId === 'string' && /^\d+$/.test(rawProjectId.trim())) {
    if (typeof rawAuthDomain === 'string' && rawAuthDomain.includes('.firebaseapp.com')) {
      return rawAuthDomain.split('.')[0];
    }
  }
  return rawProjectId;
})();

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: rawAuthDomain,
  projectId: inferredProjectId,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

if (import.meta.env.PROD) {
  const originHost = typeof window !== 'undefined' ? window.location.host : 'unknown';
  void originHost;
  if (rawAuthDomain && typeof window !== 'undefined' && rawAuthDomain !== window.location.host) {
    // no console output
  }
}

// Validate that we have a proper Firebase configuration
if (!firebaseConfig.projectId || !firebaseConfig.apiKey) {
  throw new Error('Firebase configuration is incomplete. Please check your environment variables.');
}

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Only connect to auth emulator in development if explicitly configured
// NEVER connect to emulator in production builds
if (import.meta.env.DEV && import.meta.env.VITE_USE_AUTH_EMULATOR === 'true') {
  try {
    connectAuthEmulator(auth, 'http://localhost:9099');
  } catch (error) {
    // Auth emulator already connected or not available
    void error;
  }
}

export default app;
